import { render, staticRenderFns } from "./PanelColorSelector.vue?vue&type=template&id=7c93549a&scoped=true"
import script from "./PanelColorSelector.vue?vue&type=script&lang=js"
export * from "./PanelColorSelector.vue?vue&type=script&lang=js"
import style0 from "./PanelColorSelector.vue?vue&type=style&index=0&id=7c93549a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c93549a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c93549a')) {
      api.createRecord('7c93549a', component.options)
    } else {
      api.reload('7c93549a', component.options)
    }
    module.hot.accept("./PanelColorSelector.vue?vue&type=template&id=7c93549a&scoped=true", function () {
      api.rerender('7c93549a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/subjectSetting/panelStyle/PanelColorSelector.vue"
export default component.exports